angular.module('dnecom')
    .controller('StoreCurrencyModalController', ["$scope", "$uibModalInstance", "$http", function ($scope, $uibModalInstance, $http) {
        $scope.currencies = TemplateData.value('currencies');
        $scope.currencies = $scope.currencies.filter(function( obj ) {
            return obj.code !== 'USD';
        });
        $scope.currency = null;
        $scope.selectedCurrency = null;
        $scope.unavailableMerchants = [];
        $scope.step = 1;

        $scope.selectCurrency = function () {
            if ($scope.currency) {
                $scope.unavailableMerchants = [];
                $scope.selectedCurrency = $scope.currencies.find(function (item) {
                    return item.code === $scope.currency;
                })

                if ($scope.selectedCurrency) {
                    if (!$scope.selectedCurrency.isSupportedByPayPal) {
                        $scope.unavailableMerchants.push('PayPal');
                    }
                    if (!$scope.selectedCurrency.isSupportedByStripe) {
                        $scope.unavailableMerchants.push('Stripe');
                    }
                    if (!$scope.selectedCurrency.isSupportedByBraintree) {
                        $scope.unavailableMerchants.push('Braintree');
                    }
                }
            }
        }

        $scope.saveCurrency = function() {
            $uibModalInstance.close({
                currency: $scope.selectedCurrency,
            });
        };

        $scope.getUnavailableMerchantsString = function () {
            return $scope.unavailableMerchants.join(', ');
        }

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    }]);
